package org.teddapp.project.ui.objectives

import org.teddapp.project.ui.TeddFilterRow
import org.teddapp.project.ui.TeddMenuEntry
import org.teddapp.project.ui.TeddMenu

import org.teddapp.project.ui.teddSurface

import org.teddapp.project.ui.teddClickable

import org.teddapp.project.ui.teddCardShadow

import org.teddapp.project.ui.TeddMeta

import org.teddapp.project.ui.TeddTaskItem

import org.teddapp.project.ui.TeddTagTone

import org.teddapp.project.ui.TeddTag

import org.teddapp.project.ui.TeddTabs

import org.teddapp.project.ui.TeddTab

import org.teddapp.project.ui.TeddScreenHeader

import org.teddapp.project.ui.TeddSpace

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import com.tedd.db.Skill
import org.teddapp.project.ui.TeddType
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tedd.db.Category
import com.tedd.db.Milestone
import com.tedd.db.Objective
import com.tedd.db.Task
import kotlinx.coroutines.launch
import org.teddapp.project.db.ParentKind
import org.teddapp.project.db.TeddRepositories
import org.teddapp.project.ui.ChipSize
import org.teddapp.project.ui.ChipTone
import org.teddapp.project.ui.ReorderableColumn
import org.teddapp.project.ui.TeddButton
import org.teddapp.project.ui.TeddButtonKind
import org.teddapp.project.ui.TeddButtonSize
import org.teddapp.project.ui.TeddChip
import org.teddapp.project.ui.TeddIcon
import org.teddapp.project.ui.TeddIconButton
import org.teddapp.project.ui.TeddLogo
import org.teddapp.project.ui.TeddRing
import org.teddapp.project.ui.TeddSnackbarHost
import org.teddapp.project.ui.TeddTokens
import org.teddapp.project.ui.nav.Section
import org.teddapp.project.ui.rememberReorderableState
import org.teddapp.project.ui.rememberTeddSnackbarState
import org.teddapp.project.ui.TeddDurationChips
import org.teddapp.project.ui.TeddDates

// ──────────────────────────────────────────────────────────────────────
// Parties propres à la mise en page étendue : barre latérale, en-tête, vues
// liste / grille / cartes, blocs de jalons, confirmation de suppression.
// ──────────────────────────────────────────────────────────────────────

enum class ViewMode { List, Grid, Cards }
enum class SortMode(val label: String) {
    Deadline("Échéance"),
    Progress("Progression"),
    Recent("Récent"),
    Title("A → Z"),
}

// ──────────────────────────────────────────────────────────────────────
// Sidebar (232px)
// ──────────────────────────────────────────────────────────────────────
/** Les vues et catégories des objectifs : 248 dp par défaut, de 200 à 400. */
private val OBJECTIVES_PANE = org.teddapp.project.ui.PaneSpec("objectives.sidebar", default = 248.dp, min = 200.dp, max = 400.dp, collapseBelow = 150.dp)

@Composable
internal fun Sidebar(
    categories: List<Category>,
    allCount: Int,
    activeCount: Int,
    selectedCat: String,
    onSelect: (String) -> Unit,
    categoryCount: (String) -> Int,
    onManageCategories: () -> Unit,
) {
    // Colonne posée sur le papier, séparée du contenu par un filet : la barre latérale
    // de l'application est déjà la zone en retrait de l'écran.
    // Le filet du bord est la poignée : on y règle la largeur de la colonne.
    org.teddapp.project.ui.TeddSidePane(
        spec = OBJECTIVES_PANE,
        collapsedContent = { expand ->
            org.teddapp.project.ui.TeddPaneRail(
                expand = expand,
                title = "les catégories",
                items = listOf(
                    org.teddapp.project.ui.PaneRailItem("all", "Tous mes objectifs", "goals", selectedCat == "all") { onSelect("all") },
                    org.teddapp.project.ui.PaneRailItem("active", "En cours", "play", selectedCat == "active") { onSelect("active") },
                ) + categories.map { c -> org.teddapp.project.ui.PaneRailItem(c.id, c.name, c.icon, selectedCat == c.id) { onSelect(c.id) } },
            )
        },
    ) {
    Row(Modifier.fillMaxSize()) {
        Column(
            modifier = Modifier.weight(1f).fillMaxHeight(),
            verticalArrangement = Arrangement.spacedBy(TeddSpace.S2),
        ) {
            SidebarSectionLabel("Vues")
            SidebarItem("all", "Tous mes objectifs", "goals", allCount, selectedCat == "all", onSelect)
            SidebarItem("active", "En cours", "play", activeCount, selectedCat == "active", onSelect)
            Spacer(modifier = Modifier.height(TeddSpace.S2))
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text("CATÉGORIES", Modifier.weight(1f).padding(start = TeddSpace.S1), color = TeddTokens.InkMuted, style = TeddType.Overline)
                TeddIconButton(onClick = onManageCategories, size = 28.dp) {
                    TeddIcon(name = "plus", size = 16.dp, color = TeddTokens.InkMuted)
                }
            }
            Column(
                modifier = Modifier.weight(1f).verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(2.dp),
            ) {
                categories.forEach { c ->
                    CategorySidebarItem(
                        category = c,
                        count = categoryCount(c.id),
                        selected = selectedCat == c.id,
                        onClick = { onSelect(c.id) },
                    )
                }
            }
            FocusFooterCard()
        }
    }
    }
}

@Composable
internal fun SidebarSectionLabel(label: String) {
    Text(
        text = label.uppercase(),
        modifier = Modifier.padding(start = TeddSpace.S1, top = TeddSpace.S1, bottom = TeddSpace.S1),
        color = TeddTokens.InkMuted,
        style = TeddType.Overline,
    )
}

@Composable
internal fun SidebarItem(
    id: String, label: String, icon: String, count: Int,
    selected: Boolean, onClick: (String) -> Unit,
) {
    TeddFilterRow(label, selected, { onClick(id) }, count = count) {
        TeddIcon(name = icon, size = 18.dp, color = TeddTokens.ModGoals)
    }
}

@Composable
internal fun CategorySidebarItem(
    category: Category, count: Int, selected: Boolean, onClick: () -> Unit,
) {
    // La couleur d'une catégorie est une donnée de l'utilisateur : elle reste une pastille.
    val color = runCatching { Color(parseHex(category.color)) }.getOrElse { TeddTokens.InkMuted }
    TeddFilterRow(category.name, selected, onClick, count = count) {
        Box(Modifier.padding(horizontal = 5.dp).size(8.dp).background(color, RoundedCornerShape(TeddTokens.RFull)))
    }
}

@Composable
internal fun FocusFooterCard(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .background(
                Brush.linearGradient(
                    listOf(
                        TeddTokens.LimeStrong.copy(alpha = 0.07f),
                        TeddTokens.LimeStrong.copy(alpha = 0.07f),
                    )
                )
            )
            .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RSm))
            .padding(12.dp),
    ) {
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
            Box(
                modifier = Modifier
                    .size(32.dp)
                    .clip(RoundedCornerShape(TeddTokens.RSm))
                    .background(TeddTokens.SignatureGradient, RoundedCornerShape(TeddTokens.RSm)),
                contentAlignment = Alignment.Center,
            ) {
                TeddIcon(name = "focus", size = 15.dp, color = TeddTokens.OnAction, strokeWidth = 2.dp)
            }
            Column(modifier = Modifier.weight(1f)) {
                Text("Session de focus", color = TeddTokens.Ink, fontSize = 12.sp, fontWeight = FontWeight.SemiBold)
                Text("Lance un sprint 25 min", color = TeddTokens.InkMuted, fontSize = 11.sp)
            }
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// Main header
// ──────────────────────────────────────────────────────────────────────
@Composable
internal fun MainHeader(
    selectedCat: String,
    categories: List<Category>,
    count: Int,
    search: String,
    onSearchChange: (String) -> Unit,
    viewMode: ViewMode,
    onViewModeChange: (ViewMode) -> Unit,
    sortMode: SortMode,
    onSortChange: (SortMode) -> Unit,
    onNew: () -> Unit,
) {
    val title = when (selectedCat) {
        "all" -> "Tous mes objectifs"
        "active" -> "En cours"
        else -> categories.firstOrNull { it.id == selectedCat }?.name ?: "Objectifs"
    }
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = TeddSpace.S8, end = TeddSpace.S8, top = TeddSpace.S5, bottom = TeddSpace.S3),
        verticalArrangement = Arrangement.spacedBy(TeddSpace.S4),
    ) {
        TeddScreenHeader(
            title = title,
            overline = if (count <= 1) "$count objectif" else "$count objectifs",
        ) {
            TeddButton(text = "Nouvel objectif", onClick = onNew, kind = TeddButtonKind.Primary, icon = "plus")
        }
        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(TeddSpace.S3)) {
            SearchBox(value = search, onValueChange = onSearchChange, modifier = Modifier.width(260.dp))
            Spacer(Modifier.weight(1f))
            SortSelect(value = sortMode, onChange = onSortChange)
            ViewToggle(value = viewMode, onChange = onViewModeChange)
        }
    }
}

@Composable
internal fun ViewToggle(value: ViewMode, onChange: (ViewMode) -> Unit) {
    TeddTabs(
        tabs = listOf(
            TeddTab(ViewMode.List.name, "Liste", icon = "list"),
            TeddTab(ViewMode.Grid.name, "Grille", icon = "grid"),
            TeddTab(ViewMode.Cards.name, "Cartes", icon = "cards"),
        ),
        selected = value.name,
        onSelect = { name -> ViewMode.entries.firstOrNull { it.name == name }?.let(onChange) },
    )
}

@Composable
internal fun SortSelect(value: SortMode, onChange: (SortMode) -> Unit) {
    var open by remember { mutableStateOf(false) }
    Box {
        Row(
            modifier = Modifier
                .height(32.dp)
                .clip(RoundedCornerShape(TeddTokens.RSm))
                .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm))
                .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RSm))
                .clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = null,
                    onClick = { open = true },
                )
                .padding(horizontal = 10.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(6.dp),
        ) {
            Text(
                text = "Tri : ${value.label}",
                color = TeddTokens.InkMuted,
                fontSize = 12.sp,
            )
            Box(modifier = Modifier.size(10.dp).rotate(90f)) {
                TeddIcon(name = "chevron", size = 10.dp, color = TeddTokens.InkMuted)
            }
        }
        TeddMenu(
            expanded = open,
            onDismiss = { open = false },
            width = 220.dp,
            entries = SortMode.entries.map { mode -> TeddMenuEntry(mode.label, selected = mode == value, onClick = { onChange(mode) }) },
        )
    }
}

@Composable
internal fun SearchBox(
    value: String, onValueChange: (String) -> Unit, modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier
            .height(32.dp)
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm))
            .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RSm))
            .padding(horizontal = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(6.dp),
    ) {
        TeddIcon(name = "search", size = 13.dp, color = TeddTokens.InkMuted)
        androidx.compose.foundation.text.BasicTextField(
            value = value,
            onValueChange = onValueChange,
            modifier = Modifier.weight(1f),
            singleLine = true,
            textStyle = TextStyle(color = TeddTokens.Ink, fontSize = 13.sp),
            decorationBox = { inner ->
                if (value.isEmpty()) Text("Filtrer…", color = TeddTokens.InkMuted, fontSize = 13.sp)
                inner()
            },
        )
    }
}

// ──────────────────────────────────────────────────────────────────────
// Empty state
// ──────────────────────────────────────────────────────────────────────
@Composable
internal fun EmptyStateBlock(hasSearch: Boolean, onNew: () -> Unit) {
    Box(modifier = Modifier.fillMaxSize().padding(28.dp), contentAlignment = Alignment.TopCenter) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(TeddTokens.RMd))
                .background(TeddTokens.SurfaceSunken)
                .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RMd))
                .padding(40.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Box(
                modifier = Modifier
                    .size(56.dp)
                    .clip(RoundedCornerShape(TeddTokens.RMd))
                    .background(TeddTokens.SignatureGradientSoft, RoundedCornerShape(TeddTokens.RMd)),
                contentAlignment = Alignment.Center,
            ) {
                TeddIcon(name = "target", size = 28.dp, color = TeddTokens.LimeStrong)
            }
            Spacer(modifier = Modifier.height(16.dp))
            Text(
                text = if (hasSearch) "Rien ne correspond à ta recherche." else "Aucun objectif",
                color = TeddTokens.Ink, fontSize = 16.sp, fontWeight = FontWeight.SemiBold,
            )
            Spacer(modifier = Modifier.height(4.dp))
            Text(
                text = if (hasSearch) "Essaie un autre mot-clé ou change de catégorie."
                       else "Pose ton premier objectif — teddApp le découpera en jalons et tâches.",
                color = TeddTokens.InkMuted, fontSize = 13.sp,
            )
            if (!hasSearch) {
                // Spec §6.1 : 3 conseils méthodologiques sur les objectifs SMART.
                Spacer(modifier = Modifier.height(20.dp))
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(10.dp),
                ) {
                    SmartTip(
                        emoji = "🎯",
                        title = "Spécifique & mesurable",
                        body = "Un objectif vague reste un rêve. Choisis un résultat observable : « courir 10 km sans m'arrêter » plutôt que « me remettre au sport ».",
                    )
                    SmartTip(
                        emoji = "📅",
                        title = "Temporellement borné",
                        body = "Pose une échéance — c'est elle qui rend l'objectif réel. Pas d'échéance = pas d'urgence = pas d'action.",
                    )
                    SmartTip(
                        emoji = "🧩",
                        title = "Découpé en jalons",
                        body = "Un objectif annuel est trop gros pour être travaillé en bloc. Découpe-le en 3 à 6 jalons trimestriels, puis en actions concrètes.",
                    )
                }
                Spacer(modifier = Modifier.height(20.dp))
                TeddButton(
                    text = "Ajouter un objectif",
                    onClick = onNew,
                    kind = TeddButtonKind.Primary,
                    size = TeddButtonSize.Md,
                    leadingIcon = {
                        TeddIcon(name = "plus", size = 14.dp, color = TeddTokens.OnAction, strokeWidth = 2.2.dp)
                    },
                )
            }
        }
    }
}

@Composable
internal fun SmartTip(emoji: String, title: String, body: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm))
            .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RSm))
            .padding(14.dp),
        verticalAlignment = Alignment.Top,
        horizontalArrangement = Arrangement.spacedBy(12.dp),
    ) {
        Text(emoji, fontSize = 18.sp)
        Column(modifier = Modifier.weight(1f)) {
            Text(title, color = TeddTokens.Ink, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
            Spacer(modifier = Modifier.height(2.dp))
            Text(body, color = TeddTokens.InkMuted, fontSize = 12.sp, lineHeight = 17.sp)
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// List row + expand
// ──────────────────────────────────────────────────────────────────────
@Composable
internal fun ObjectiveListRow(
    objective: Objective,
    category: Category?,
    expanded: Boolean,
    repos: TeddRepositories,
    onToggleExpand: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    onToggleTask: (Task) -> Unit,
    onSendToPomodoro: ((Task) -> Unit)? = null,
    skill: Skill? = null,
    onOpenSkill: ((String) -> Unit)? = null,
) {
    val color = category?.let { runCatching { Color(parseHex(it.color)) }.getOrNull() }
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .teddSurface(RoundedCornerShape(TeddTokens.RLg)),
    ) {
        // ── Header ──
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = null,
                    onClick = onToggleExpand,
                )
                .padding(horizontal = 18.dp, vertical = 16.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(16.dp),
        ) {
            TeddRing(
                value = objective.progress.toInt().coerceIn(0, 100),
                size = 56.dp,
                strokeWidth = 5.dp,
                sub = "%",
            )
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(TeddSpace.S1)) {
                Text(
                    text = objective.title,
                    color = TeddTokens.Ink,
                    style = TeddType.Title2.copy(fontSize = 18.sp, lineHeight = 24.sp),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                if (!objective.description.isNullOrBlank()) {
                    Text(
                        text = objective.description!!,
                        color = TeddTokens.InkMuted,
                        style = TeddType.Body,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
            }
            if (category != null) TeddTag(category.name, tone = TeddTagTone.Outline, dotColor = color)
            formatDateFr(objective.deadline, long = false)?.let { pretty ->
                val late = isOverdue(objective.deadline)
                TeddTag(
                    text = if (late) "$pretty · dépassée" else pretty,
                    tone = if (late) TeddTagTone.Danger else TeddTagTone.Neutral,
                    icon = if (late) "alert" else "calendar",
                )
            }
            Spacer(modifier = Modifier.width(6.dp))
            TeddIconButton(onClick = onEdit, size = 28.dp) {
                TeddIcon(name = "edit", size = 14.dp, color = TeddTokens.InkMuted)
            }
            TeddIconButton(onClick = onDelete, size = 28.dp) {
                TeddIcon(name = "trash", size = 14.dp, color = TeddTokens.InkMuted)
            }
            Box(
                modifier = Modifier.size(28.dp).rotate(if (expanded) 90f else 0f),
                contentAlignment = Alignment.Center,
            ) {
                TeddIcon(name = "chevron-right", size = 16.dp, color = TeddTokens.InkMuted)
            }
        }
        // ── Expanded section ──
        if (expanded) {
            ObjectiveExpandedBlock(
                objective = objective,
                repos = repos,
                onToggleTask = onToggleTask,
                onSendToPomodoro = onSendToPomodoro,
                skill = skill,
                onOpenSkill = onOpenSkill,
            )
        }
    }
}

@Composable
internal fun ObjectiveExpandedBlock(
    objective: Objective,
    repos: TeddRepositories,
    onToggleTask: (Task) -> Unit,
    onSendToPomodoro: ((Task) -> Unit)? = null,
    skill: Skill? = null,
    onOpenSkill: ((String) -> Unit)? = null,
) {
    val milestones by repos.milestones.observeByObjective(objective.id).collectAsState(emptyList())
    val allTasks by repos.tasks.observeAll().collectAsState(emptyList())
    val stepIds = milestones.map { it.id }
    val pendingTasks = remember(allTasks, stepIds) {
        allTasks
            .filter { it.is_deleted == 0L && it.status != "done" && it.parent_id in stepIds }
            .sortedWith(compareBy<Task> { stepIds.indexOf(it.parent_id) }.thenBy { it.order_index })
    }
    val nextTask = pendingTasks.firstOrNull()
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(TeddTokens.SurfaceSunken)
            .padding(start = 18.dp, end = 18.dp, top = 12.dp, bottom = 16.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp),
    ) {
        // La compétence que l'objectif fait progresser : un tap ramène à sa fiche.
        if (skill != null) {
            val skillColor = runCatching { Color(parseHex(skill.color)) }.getOrNull() ?: TeddTokens.LimeStrong
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(6.dp),
                modifier = Modifier
                    .padding(bottom = 8.dp)
                    .clickable(interactionSource = remember { MutableInteractionSource() }, indication = null) { onOpenSkill?.invoke(skill.id) },
            ) {
                TeddIcon(name = skill.icon, size = 11.dp, color = skillColor, strokeWidth = 2.dp)
                Text("COMPÉTENCE · ${skill.name.uppercase()} →", style = TeddType.Overline, color = skillColor)
            }
        }
        if (nextTask != null) {
            NextMicroTaskCard(
                task = nextTask,
                stepTitle = milestones.firstOrNull { it.id == nextTask.parent_id }?.title ?: "",
                remaining = pendingTasks.size - 1,
                onDone = { onToggleTask(nextTask) },
                onFocus = onSendToPomodoro?.let { fn -> { fn(nextTask) } },
            )
        }
        ObjectivePastDeadlineBlock(objective = objective, repos = repos)
        if (!objective.motivation.isNullOrBlank()) {
            Row(verticalAlignment = Alignment.Top, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                TeddIcon(name = "spark", size = 13.dp, color = TeddTokens.LimeStrong, strokeWidth = 2.dp)
                Text(
                    text = "« ${objective.motivation!!} »",
                    color = TeddTokens.InkMuted,
                    fontSize = 12.5.sp,
                    fontStyle = FontStyle.Italic,
                )
            }
            Spacer(modifier = Modifier.height(12.dp))
        }
        if (milestones.isEmpty()) {
            Text(
                text = "Aucune étape pour l'instant.",
                color = TeddTokens.InkMuted,
                fontSize = 12.sp,
                fontStyle = FontStyle.Italic,
            )
        } else {
            val scope = rememberCoroutineScope()
            val milestoneReorder = rememberReorderableState()
            ReorderableColumn(
                items = milestones,
                keyOf = { it.id },
                state = milestoneReorder,
                onReorder = { from, to ->
                    scope.launch { repos.milestones.reorderInObjective(objective.id, from, to) }
                },
                modifier = Modifier.fillMaxWidth(),
            ) { index, ms, handleMod ->
                Box(modifier = Modifier.fillMaxWidth().padding(bottom = 12.dp)) {
                    MilestoneBlock(
                        milestone = ms,
                        index = index,
                        repos = repos,
                        onToggleTask = onToggleTask,
                        onSendToPomodoro = onSendToPomodoro,
                        dragHandleModifier = handleMod,
                        dropLock = milestoneReorder.recentlyDropped,
                    )
                }
            }
        }
    }
}

@Composable
internal fun MilestoneBlock(
    milestone: Milestone,
    index: Int,
    repos: TeddRepositories,
    onToggleTask: (Task) -> Unit,
    onRequestDelete: (() -> Unit)? = null,
    onSendToPomodoro: ((Task) -> Unit)? = null,
    /** Modifier à appliquer sur la handle du jalon — non-null = on est dans une ReorderableColumn. */
    dragHandleModifier: Modifier? = null,
    /** Vrai dans les 100 ms suivant un drop de jalon — bloque les clics fantômes sur ce bloc. */
    dropLock: Boolean = false,
) {
    val tasks by repos.tasks.observeByMilestone(milestone.id).collectAsState(emptyList())

    val scope = rememberCoroutineScope()
    var newTaskTitle by remember { mutableStateOf("") }
    var newTaskMinutes by remember { mutableStateOf<Int?>(10) }
    var editingTask by remember { mutableStateOf<Task?>(null) }
    var addingTask by remember { mutableStateOf(false) }
    // Spec §8.2 : édition inline du titre du jalon, save on focus loss / Enter.
    var editingTitle by remember(milestone.id, milestone.title) { mutableStateOf(milestone.title) }

    Column {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = 6.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            if (dragHandleModifier != null) {
                Box(
                    modifier = dragHandleModifier
                        .size(20.dp)
                        .clip(RoundedCornerShape(TeddTokens.RXs)),
                    contentAlignment = Alignment.Center,
                ) {
                    TeddIcon(name = "grip", size = 14.dp, color = TeddTokens.InkSubtle)
                }
            }
            Text(
                text = "ÉTAPE ${(index + 1).toString().padStart(2, '0')}",
                color = TeddTokens.InkMuted,
                fontSize = 10.sp,
                fontWeight = FontWeight.SemiBold,
                letterSpacing = 0.5.sp,
                modifier = Modifier
                    .clip(RoundedCornerShape(TeddTokens.RXs))
                    .background(TeddTokens.SurfaceSunken, RoundedCornerShape(TeddTokens.RXs))
                    .padding(horizontal = 6.dp, vertical = 2.dp),
            )
            // Édition inline du titre — save sur perte de focus ou Entrée (si non-vide ET changé).
            Box(modifier = Modifier.weight(1f)) {
                androidx.compose.foundation.text.BasicTextField(
                    value = editingTitle,
                    onValueChange = { editingTitle = it },
                    singleLine = true,
                    textStyle = TextStyle(
                        color = TeddTokens.Ink,
                        fontSize = 13.sp,
                        fontWeight = FontWeight.SemiBold,
                    ),
                    cursorBrush = androidx.compose.ui.graphics.SolidColor(TeddTokens.LimeStrong),
                    keyboardOptions = androidx.compose.foundation.text.KeyboardOptions(
                        imeAction = androidx.compose.ui.text.input.ImeAction.Done,
                    ),
                    keyboardActions = androidx.compose.foundation.text.KeyboardActions(
                        onDone = {
                            val trimmed = editingTitle.trim()
                            if (trimmed.isNotEmpty() && trimmed != milestone.title) {
                                scope.launch {
                                    repos.milestones.update(
                                        id = milestone.id,
                                        title = trimmed,
                                        description = milestone.description,
                                        deadline = milestone.deadline,
                                        progress = milestone.progress,
                                        orderIndex = milestone.order_index,
                                    )
                                }
                            } else if (trimmed.isEmpty()) {
                                editingTitle = milestone.title
                            }
                        }
                    ),
                    modifier = Modifier.onFocusChanged { state ->
                        if (!state.isFocused) {
                            val trimmed = editingTitle.trim()
                            if (trimmed.isNotEmpty() && trimmed != milestone.title) {
                                scope.launch {
                                    repos.milestones.update(
                                        id = milestone.id,
                                        title = trimmed,
                                        description = milestone.description,
                                        deadline = milestone.deadline,
                                        progress = milestone.progress,
                                        orderIndex = milestone.order_index,
                                    )
                                }
                            } else if (trimmed.isEmpty()) {
                                editingTitle = milestone.title
                            }
                        }
                    },
                )
            }
            if (!milestone.deadline.isNullOrBlank()) {
                Text(TeddDates.formatShort(milestone.deadline) ?: "", color = TeddTokens.InkMuted, fontSize = 11.sp)
            }
            TeddRing(value = milestone.progress.toInt(), size = 22.dp, strokeWidth = 2.5.dp, showLabel = false)
            if (onRequestDelete != null) {
                TeddIconButton(onClick = onRequestDelete, size = 24.dp) {
                    TeddIcon(name = "trash", size = 12.dp, color = TeddTokens.InkSubtle)
                }
            }
        }
        // Tasks (réordonnables intra-jalon — spec §7.5).
        val taskReorder = rememberReorderableState()
        ReorderableColumn(
            items = tasks,
            keyOf = { it.id },
            state = taskReorder,
            onReorder = { from, to ->
                scope.launch { repos.tasks.reorderInMilestone(milestone.id, from, to) }
            },
            modifier = Modifier.fillMaxWidth(),
        ) { _, t, handleMod ->
            // Verrou anti-clic : si on vient de drop OU si un drag de jalon vient de drop,
            // on ignore les onToggle/onDelete pendant 100 ms (spec §8.1).
            val locked = taskReorder.recentlyDropped || dropLock
            TaskRowWithDelete(
                task = t,
                onToggle = { if (!locked) onToggleTask(t) },
                onDelete = {
                    if (locked) return@TaskRowWithDelete
                    scope.launch {
                        repos.tasks.softDelete(t.id)
                        repos.progress.onTaskDeleted(milestone.id)
                    }
                },
                onSendToPomodoro = onSendToPomodoro?.let { fn -> { if (!locked) fn(t) } },
                onEdit = { if (!locked) editingTask = t },
                dragHandleModifier = handleMod,
            )
        }
        editingTask?.let { t ->
            MicroTaskEditor(task = t, repos = repos, onClose = { editingTask = null })
        }
        // Add task affordance
        if (addingTask) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 4.dp)
                    .clip(RoundedCornerShape(TeddTokens.RSm))
                    .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RSm))
                    .border(1.dp, TeddTokens.LimeStrong.copy(alpha = 0.3f), RoundedCornerShape(TeddTokens.RSm))
                    .padding(horizontal = 8.dp, vertical = 6.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(10.dp),
            ) {
                TeddIcon(name = "plus", size = 14.dp, color = TeddTokens.LimeStrong, strokeWidth = 2.dp)
                Box(modifier = Modifier.weight(1f)) {
                    androidx.compose.foundation.text.BasicTextField(
                        value = newTaskTitle,
                        onValueChange = { newTaskTitle = it },
                        singleLine = true,
                        textStyle = TextStyle(color = TeddTokens.Ink, fontSize = 13.sp),
                        cursorBrush = androidx.compose.ui.graphics.SolidColor(TeddTokens.LimeStrong),
                        keyboardOptions = androidx.compose.foundation.text.KeyboardOptions(
                            imeAction = androidx.compose.ui.text.input.ImeAction.Done,
                        ),
                        keyboardActions = androidx.compose.foundation.text.KeyboardActions(
                            onDone = {
                                val t = newTaskTitle.trim()
                                if (t.isNotEmpty()) {
                                    scope.launch {
                                        repos.tasks.create(
                                            parentKind = ParentKind.Milestone,
                                            parentId = milestone.id,
                                            title = t,
                                            estimatedMinutes = newTaskMinutes?.toLong(),
                                        )
                                        repos.progress.onTaskCreated(milestone.id)
                                    }
                                    newTaskTitle = ""
                                }
                                addingTask = false
                            }
                        ),
                        decorationBox = { inner ->
                            if (newTaskTitle.isEmpty()) {
                                Text("Micro-tâche de 5 à 10 minutes, puis Entrée…", color = TeddTokens.InkSubtle, fontSize = 13.sp)
                            }
                            inner()
                        },
                    )
                }
                TeddIconButton(
                    onClick = {
                        val t = newTaskTitle.trim()
                        if (t.isNotEmpty()) {
                            scope.launch {
                                repos.tasks.create(
                                    parentKind = ParentKind.Milestone,
                                    parentId = milestone.id,
                                    title = t,
                                    estimatedMinutes = newTaskMinutes?.toLong(),
                                )
                                repos.progress.onTaskCreated(milestone.id)
                            }
                            newTaskTitle = ""
                        }
                        addingTask = false
                    },
                    size = 24.dp,
                ) {
                    TeddIcon(name = "check", size = 13.dp, color = TeddTokens.LimeStrong, strokeWidth = 2.5.dp)
                }
                TeddIconButton(
                    onClick = { newTaskTitle = ""; addingTask = false },
                    size = 24.dp,
                ) {
                    Box(modifier = Modifier.rotate(45f)) {
                        TeddIcon(name = "plus", size = 13.dp, color = TeddTokens.InkMuted, strokeWidth = 2.dp)
                    }
                }
            }
            TeddDurationChips(
                value = newTaskMinutes,
                onChange = { newTaskMinutes = it },
                modifier = Modifier.padding(start = 8.dp, top = 8.dp),
                label = "Durée",
            )
        } else {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 4.dp)
                    .clip(RoundedCornerShape(TeddTokens.RSm))
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                        onClick = { addingTask = true },
                    )
                    .padding(horizontal = 8.dp, vertical = 6.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                TeddIcon(name = "plus", size = 13.dp, color = TeddTokens.InkMuted, strokeWidth = 2.dp)
                Text(
                    text = "Ajouter une micro-tâche",
                    color = TeddTokens.InkMuted,
                    fontSize = 12.sp,
                    fontWeight = FontWeight.Medium,
                )
            }
        }
    }
}

@Composable
internal fun TaskRowWithDelete(
    task: Task,
    onToggle: () -> Unit,
    onDelete: () -> Unit,
    onSendToPomodoro: (() -> Unit)? = null,
    onEdit: (() -> Unit)? = null,
    dragHandleModifier: Modifier? = null,
) {
    val done = task.status == "done"
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .padding(horizontal = 8.dp, vertical = 6.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(10.dp),
    ) {
        if (dragHandleModifier != null) {
            Box(
                modifier = dragHandleModifier
                    .size(16.dp)
                    .clip(RoundedCornerShape(TeddTokens.RXs)),
                contentAlignment = Alignment.Center,
            ) {
                TeddIcon(name = "grip", size = 11.dp, color = TeddTokens.InkSubtle)
            }
        }
        Box(
            modifier = Modifier
                .size(18.dp)
                .clip(RoundedCornerShape(TeddTokens.RXs))
                .then(
                    if (done) Modifier.background(TeddTokens.SignatureGradient, RoundedCornerShape(TeddTokens.RXs))
                    else Modifier.border(1.5.dp, TeddTokens.InkSubtle, RoundedCornerShape(TeddTokens.RXs))
                )
                .clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = null,
                    onClick = onToggle,
                ),
            contentAlignment = Alignment.Center,
        ) {
            if (done) {
                TeddIcon(name = "check", size = 12.dp, color = TeddTokens.OnAction, strokeWidth = 2.5.dp)
            }
        }
        Text(
            text = task.title,
            color = if (done) TeddTokens.InkMuted else TeddTokens.Ink,
            fontSize = 13.5.sp,
            fontWeight = FontWeight.Medium,
            modifier = Modifier
                .weight(1f)
                .clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = null,
                    onClick = onToggle,
                ),
            textDecoration = if (done) androidx.compose.ui.text.style.TextDecoration.LineThrough else null,
        )
        org.teddapp.project.ui.projects.estimateLabel(task.estimated_minutes, task.real_minutes)?.let { label ->
            Text(text = label, color = TeddTokens.InkMuted, fontSize = 11.sp)
        }
        val rec = org.teddapp.project.db.TaskRecurrence.of(task.recurrence)
        if (rec != org.teddapp.project.db.TaskRecurrence.None) {
            Text(
                text = rec.label.lowercase(),
                color = TeddTokens.InkMuted,
                fontSize = 10.5.sp,
                modifier = Modifier
                    .clip(RoundedCornerShape(TeddTokens.RFull))
                    .background(TeddTokens.SurfaceSunken, RoundedCornerShape(TeddTokens.RFull))
                    .padding(horizontal = 6.dp, vertical = 1.dp),
            )
        }
        val due = formatDateFr(task.due_date, long = false)
        if (due != null) {
            Text(
                text = due,
                color = TeddTokens.InkMuted,
                fontSize = 11.sp,
            )
        }
        if (onSendToPomodoro != null && !done) {
            Box(
                modifier = Modifier
                    .size(24.dp)
                    .clip(RoundedCornerShape(TeddTokens.RXs))
                    .background(TeddTokens.LimeSoft, RoundedCornerShape(TeddTokens.RXs))
                    .clickable(
                        interactionSource = remember { MutableInteractionSource() },
                        indication = null,
                        onClick = onSendToPomodoro,
                    ),
                contentAlignment = Alignment.Center,
            ) {
                TeddIcon(name = "plus", size = 12.dp, color = TeddTokens.LimeStrong, strokeWidth = 2.4.dp)
            }
        }
        if (onEdit != null) {
            TeddIconButton(onClick = onEdit, size = 24.dp) {
                TeddIcon(name = "edit", size = 11.dp, color = TeddTokens.InkSubtle)
            }
        }
        TeddIconButton(onClick = onDelete, size = 24.dp) {
            TeddIcon(name = "trash", size = 11.dp, color = TeddTokens.InkSubtle)
        }
    }
}

@Composable
internal fun TaskRow(task: Task, onToggle: () -> Unit) {
    TeddTaskItem(
        title = task.title,
        done = task.status == "done",
        onToggle = { onToggle() },
        due = formatDateFr(task.due_date),
        overdue = task.status != "done" && isOverdue(task.due_date),
        meta = listOfNotNull(task.estimated_minutes?.let { TeddMeta("$it min", "focus") }),
    )
}

// ──────────────────────────────────────────────────────────────────────
// Grid card (compact)
// ──────────────────────────────────────────────────────────────────────
@Composable
internal fun ObjectiveGridCard(
    objective: Objective,
    category: Category?,
    onOpen: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
) {
    val color = category?.let { runCatching { Color(parseHex(it.color)) }.getOrNull() }
    Box(
        modifier = Modifier
            .clip(RoundedCornerShape(TeddTokens.RMd))
            .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RMd))
            .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RMd))
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                onClick = onOpen,
            )
            .padding(16.dp),
    ) {
        Column(verticalArrangement = Arrangement.spacedBy(14.dp)) {
            if (category != null) {
                TeddChip(
                    text = category.name,
                    color = color,
                    tone = ChipTone.Soft,
                    size = ChipSize.Sm,
                    leadingIcon = {
                        TeddIcon(name = category.icon, size = 11.dp, color = color ?: TeddTokens.LimeStrong, strokeWidth = 2.dp)
                    },
                )
            }
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp),
            ) {
                TeddRing(
                    value = objective.progress.toInt().coerceIn(0, 100),
                    size = 52.dp,
                    strokeWidth = 5.dp,
                    accent = color,
                    sub = "%",
                )
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = objective.title,
                        color = TeddTokens.Ink,
                        fontSize = 14.5.sp,
                        fontWeight = FontWeight.SemiBold,
                        letterSpacing = (-0.15).sp,
                        maxLines = 2,
                    )
                    if (!objective.deadline.isNullOrBlank()) {
                        Spacer(modifier = Modifier.height(3.dp))
                        Text(
                            text = objective.deadline!!,
                            color = TeddTokens.InkMuted,
                            fontSize = 11.sp,
                        )
                    }
                }
            }
        }
        // Edit/Delete floating top-right
        Row(
            modifier = Modifier.align(Alignment.TopEnd),
            horizontalArrangement = Arrangement.spacedBy(2.dp),
        ) {
            TeddIconButton(onClick = onEdit, size = 24.dp) {
                TeddIcon(name = "edit", size = 12.dp, color = TeddTokens.InkMuted)
            }
            TeddIconButton(onClick = onDelete, size = 24.dp) {
                TeddIcon(name = "trash", size = 12.dp, color = TeddTokens.InkMuted)
            }
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// Hero card (rich, with milestone bars + next task)
// ──────────────────────────────────────────────────────────────────────
@Composable
internal fun ObjectiveHeroCard(
    objective: Objective,
    category: Category?,
    repos: TeddRepositories,
    onOpen: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
    onToggleTask: (Task) -> Unit,
) {
    val color = category?.let { runCatching { Color(parseHex(it.color)) }.getOrNull() }
    val milestones by repos.milestones.observeByObjective(objective.id).collectAsState(emptyList())

    // Next task = première action non-done du premier jalon (V1, suffisant pour l'aperçu).
    val firstMs = milestones.firstOrNull()
    val msTasksFlow = remember(firstMs?.id) {
        if (firstMs != null) repos.tasks.observeByMilestone(firstMs.id)
        else kotlinx.coroutines.flow.flowOf(emptyList())
    }
    val msTasks by msTasksFlow.collectAsState(emptyList())
    val next: Pair<Milestone, Task>? = firstMs?.let { ms ->
        msTasks.firstOrNull { it.status != "done" }?.let { ms to it }
    }

    Column(
        modifier = Modifier
            .clip(RoundedCornerShape(TeddTokens.RLg))
            .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RLg))
            .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RLg))
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                onClick = onOpen,
            ),
    ) {
        // Gradient header strip
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(4.dp)
                .background(
                    Brush.linearGradient(
                        colors = listOf(color ?: TeddTokens.LimeStrong, TeddTokens.LimeStrong),
                    )
                )
        )
        Row(modifier = Modifier.padding(20.dp), horizontalArrangement = Arrangement.spacedBy(18.dp)) {
            TeddRing(
                value = objective.progress.toInt().coerceIn(0, 100),
                size = 92.dp,
                strokeWidth = 7.dp,
                accent = color,
                sub = "%",
            )
            Column(modifier = Modifier.weight(1f)) {
                Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    if (category != null) {
                        TeddChip(
                            text = category.name,
                            color = color,
                            tone = ChipTone.Soft,
                            size = ChipSize.Sm,
                            leadingIcon = {
                                TeddIcon(name = category.icon, size = 11.dp, color = color ?: TeddTokens.LimeStrong, strokeWidth = 2.dp)
                            },
                        )
                    }
                    formatDateFr(objective.deadline, long = true)?.let { pretty ->
                        Text(text = pretty, color = TeddTokens.InkMuted, fontSize = 11.sp)
                    }
                }
                Spacer(modifier = Modifier.height(6.dp))
                Text(
                    text = objective.title,
                    color = TeddTokens.Ink,
                    fontSize = 18.sp,
                    fontWeight = FontWeight.SemiBold,
                    letterSpacing = (-0.25).sp,
                )
                if (!objective.description.isNullOrBlank()) {
                    Spacer(modifier = Modifier.height(6.dp))
                    Text(
                        text = objective.description!!,
                        color = TeddTokens.InkMuted,
                        fontSize = 12.5.sp,
                        maxLines = 2,
                    )
                }
            }
            Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                TeddIconButton(onClick = onEdit, size = 28.dp) {
                    TeddIcon(name = "edit", size = 13.dp, color = TeddTokens.InkMuted)
                }
                TeddIconButton(onClick = onDelete, size = 28.dp) {
                    TeddIcon(name = "trash", size = 13.dp, color = TeddTokens.InkMuted)
                }
            }
        }
        // Milestone progress bars
        if (milestones.isNotEmpty()) {
            Row(
                modifier = Modifier.padding(start = 20.dp, end = 20.dp, bottom = 8.dp).fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(4.dp),
            ) {
                milestones.forEach { ms ->
                    val pct = ms.progress.toInt().coerceIn(0, 100)
                    Box(
                        modifier = Modifier
                            .weight(1f)
                            .height(5.dp)
                            .clip(RoundedCornerShape(3.dp))
                            .background(TeddTokens.SurfaceSunken, RoundedCornerShape(3.dp)),
                    ) {
                        if (pct > 0) {
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth(pct / 100f)
                                    .height(5.dp)
                                    .background(
                                        if (pct == 100) TeddTokens.Success.let { c -> Brush.linearGradient(listOf(c, c)) }
                                        else TeddTokens.SignatureGradient,
                                        RoundedCornerShape(3.dp),
                                    )
                            )
                        }
                    }
                }
            }
            Row(
                modifier = Modifier.padding(start = 20.dp, end = 20.dp, bottom = 14.dp).fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                Text(
                    text = "${milestones.size} étape${if (milestones.size > 1) "s" else ""}",
                    color = TeddTokens.InkMuted,
                    fontSize = 11.sp,
                )
            }
        }
        // Next task preview
        if (next != null) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .background(TeddTokens.SurfaceSunken)
                    .border(1.dp, TeddTokens.Line, RoundedCornerShape(0.dp))
                    .padding(horizontal = 16.dp, vertical = 12.dp),
            ) {
                Text(
                    text = "PROCHAINE ACTION",
                    color = TeddTokens.InkMuted,
                    fontSize = 10.sp,
                    fontWeight = FontWeight.SemiBold,
                    letterSpacing = 0.6.sp,
                    modifier = Modifier.padding(start = 4.dp, bottom = 4.dp),
                )
                NextTaskRow(
                    task = next.second,
                    milestoneName = next.first.title,
                    onToggle = { onToggleTask(next.second) },
                )
            }
        }
    }
}

@Composable
internal fun NextTaskRow(task: Task, milestoneName: String, onToggle: () -> Unit) {
    val done = task.status == "done"
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(TeddTokens.RSm))
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                onClick = onToggle,
            )
            .padding(horizontal = 6.dp, vertical = 6.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(10.dp),
    ) {
        Box(
            modifier = Modifier
                .size(18.dp)
                .clip(RoundedCornerShape(TeddTokens.RXs))
                .then(
                    if (done) Modifier.background(TeddTokens.SignatureGradient, RoundedCornerShape(TeddTokens.RXs))
                    else Modifier.border(1.5.dp, TeddTokens.InkSubtle, RoundedCornerShape(TeddTokens.RXs))
                ),
            contentAlignment = Alignment.Center,
        ) {
            if (done) TeddIcon(name = "check", size = 12.dp, color = TeddTokens.OnAction, strokeWidth = 2.5.dp)
        }
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = task.title,
                color = if (done) TeddTokens.InkMuted else TeddTokens.Ink,
                fontSize = 12.5.sp,
                fontWeight = FontWeight.Medium,
                textDecoration = if (done) androidx.compose.ui.text.style.TextDecoration.LineThrough else null,
            )
            Text(
                text = milestoneName,
                color = TeddTokens.InkMuted,
                fontSize = 11.sp,
            )
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// Confirm delete dialog
// ──────────────────────────────────────────────────────────────────────
@Composable
internal fun ConfirmDeleteDialog(
    objective: Objective,
    onCancel: () -> Unit,
    onConfirm: () -> Unit,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.42f))
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                onClick = onCancel,
            ),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            modifier = Modifier
                .width(380.dp)
                .clip(RoundedCornerShape(TeddTokens.RMd))
                .background(TeddTokens.Surface, RoundedCornerShape(TeddTokens.RMd))
                .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RMd))
                .clickable(
                    interactionSource = remember { MutableInteractionSource() },
                    indication = null,
                    onClick = {},
                )
                .padding(22.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Box(
                    modifier = Modifier
                        .size(40.dp)
                        .clip(RoundedCornerShape(TeddTokens.RSm))
                        .background(TeddTokens.DangerSoft, RoundedCornerShape(TeddTokens.RSm)),
                    contentAlignment = Alignment.Center,
                ) {
                    TeddIcon(name = "trash", size = 18.dp, color = TeddTokens.Danger)
                }
                Column {
                    Text("Supprimer l'objectif ?", color = TeddTokens.Ink, fontSize = 15.sp, fontWeight = FontWeight.SemiBold)
                    Text("Cette action est définitive.", color = TeddTokens.InkMuted, fontSize = 12.sp)
                }
            }
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(TeddTokens.RSm))
                    .background(TeddTokens.SurfaceSunken, RoundedCornerShape(TeddTokens.RSm))
                    .border(1.dp, TeddTokens.Line, RoundedCornerShape(TeddTokens.RSm))
                    .padding(12.dp),
            ) {
                Text(
                    text = "« ${objective.title} »",
                    color = TeddTokens.Ink,
                    fontSize = 13.sp,
                    fontWeight = FontWeight.SemiBold,
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.End),
            ) {
                TeddButton(
                    text = "Annuler",
                    onClick = onCancel,
                    kind = TeddButtonKind.Secondary,
                    size = TeddButtonSize.Md,
                )
                TeddButton(
                    text = "Supprimer",
                    onClick = onConfirm,
                    kind = TeddButtonKind.Danger,
                    size = TeddButtonSize.Md,
                )
            }
        }
    }
}

// ──────────────────────────────────────────────────────────────────────
// helpers
// ──────────────────────────────────────────────────────────────────────
internal fun parseHex(hex: String): Long {
    val clean = hex.trimStart('#')
    val rgb = clean.toLong(16)
    return 0xFF000000L or rgb
}
